module.exports = __webpack_public_path__ + "static/media/red.68a3196d.ogg";